import { useState } from 'react';
import 'prop-types';
import { useSelector } from 'react-redux';
import { useBrand } from '@atc/brand';
import { useFeatures } from '@atc/features';
import { sendClick } from 'reaxl-analytics';
import { ndsEsntialBuyOnlineClick } from 'reaxl-analytics-handlers';
import { AnimatedButton, Button, DisclaimerText } from 'reaxl';
import { useWalletCalcConfig, debugWallet } from 'wallet-manager';
import { getDeal, saveDeal } from 'wallet-deals';
import getEcommLinkWithWalletData from '../utilities/getEcommLinkWithWalletData/getEcommLinkWithWalletData.js';
import getTransformedEcommLink from '../utilities/getTransformedEcommLink.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function EsntialBuyNowCTA(_ref) {
  let {
    analyticsData,
    bsStyle = 'secondary',
    className,
    saveDealXgFetcher,
    dealsDuck,
    disclaimer,
    env,
    href = '',
    label = 'Continue Online',
    listing,
    nationalRates,
    onClick = () => {},
    ownerTrackingId,
    paymentsDuck,
    zip = '',
    ...rest
  } = _ref;
  const {
    brand: [, {
      consumer_brand: consumerBrand
    }],
    dealer_website_link: [transformDealerWebsiteLink, dealerWebsiteConfig]
  } = useFeatures(['brand', 'dealer_website_link']);
  const brand = useSelector(state => state?.brand || '');
  const {
    brands
  } = useBrand();
  const shouldRemoveUtmParams = [brands.ATC_BRAND, brands.KBB_BRAND].includes(brand);

  // not destructuring or defaulting listing due downstream rules for defined or undefined object
  const owner = listing?.owner ?? {};
  const parentId = listing?.marketExtension?.parentOwnerId;
  const fallbackOwnerId = parentId ?? (typeof owner === 'number' ? owner : owner.id);
  const dealerId = ownerTrackingId ?? fallbackOwnerId;
  const ecommercePaymentsInfo = useSelector(state => paymentsDuck.selectors.getEcommercePaymentsInfo(state, true, listing?.pricingDetail));
  const {
    id: dealXgId
  } = useSelector(state => dealsDuck?.selectors?.getDealByListingVin(state, listing?.vin)) || {};
  const payments = useSelector(paymentsDuck?.selectors.getDuckState);
  const {
    cashDealPrice,
    disableTrade
  } = useWalletCalcConfig(payments, listing);
  const [buttonState, setButtonState] = useState(null);
  let baseUrl;
  if (typeof window !== 'undefined') {
    baseUrl = window?.location?.href;
  }
  if (!href) return null;
  const getEcommHref = async existingDealXgId => {
    if (existingDealXgId) {
      return getTransformedEcommLink(href, label, existingDealXgId, transformDealerWebsiteLink ? dealerWebsiteConfig : {}, baseUrl, dealerId, shouldRemoveUtmParams);
    }
    return getEcommLinkWithWalletData(href, ecommercePaymentsInfo, zip, baseUrl, dealerId);
  };
  const handleClick = async event => {
    event.stopPropagation();
    event.preventDefault();
    sendClick(ndsEsntialBuyOnlineClick, event, analyticsData);
    onClick();
    let existingDealXgId;
    if (!dealXgId && !!saveDealXgFetcher) {
      const {
        deal
      } = getDeal(listing, payments, nationalRates, false, cashDealPrice, disableTrade);
      const saveIcoData = payments?.tradeIn?.ico?.length;
      setButtonState('loading');
      const response = await saveDeal({
        consumerBrand,
        listing,
        deal,
        zip,
        walletId: payments?.walletId || null,
        componentName: 'EsntialBuyNowCTA',
        saveDealXgFetcher,
        isEsntial: true,
        icoTradeIn: saveIcoData ? payments?.tradeIn?.ico?.[0] : undefined,
        env
      });
      setButtonState('loaded');
      if (response && typeof response === 'string') {
        existingDealXgId = response;
      } else {
        // eslint-disable-next-line no-console
        console.log('Deal creation failed for esntial');
      }
    } else {
      existingDealXgId = dealXgId;
    }
    const ecommHref = await getEcommHref(existingDealXgId);
    if (ecommHref) {
      debugWallet('UDS', 'Esntial Deeplink URL:', ecommHref);
      window.open(ecommHref, '_self', 'nofollow, noopener');
    }
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [saveDealXgFetcher ? /*#__PURE__*/jsx(AnimatedButton, {
      bsStyle: bsStyle,
      buttonState: buttonState,
      buttonText: label,
      className: className,
      "data-cmp": "animatedEsntialCTA",
      loadedText: label,
      onClick: handleClick,
      type: "button",
      ...rest
    }) : /*#__PURE__*/jsx(Button, {
      "data-cmp": "esntialCTA",
      bsStyle: bsStyle,
      onClick: handleClick,
      className: className,
      ...rest,
      children: label
    }), !!disclaimer && /*#__PURE__*/jsx(DisclaimerText, {
      className: "text-center text-inherit margin-bottom-4",
      componentClass: "div",
      children: disclaimer
    })]
  });
}
export { EsntialBuyNowCTA as default };
